import { Typography, Grid } from "@mui/material";
import { useTheme, lighten } from "@mui/material/styles";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SignaturePad from "react-signature-pad-wrapper";
import { Props } from "./interfaces";

const SignaturePadContainer = ({ text, refOBj, minPencilWidth, maxPencilWidth }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const tRP = "components.signature_pad";

  useEffect(() => {
    // Wait for the canvas to mount, then ensure it's transparent
    const signaturePadCurrent: SignaturePad | null = refOBj?.current ?? null;
    const canvasCurrent = signaturePadCurrent?.canvas.current;

    if (canvasCurrent) {
      const ctx = canvasCurrent?.getContext("2d");
      if (ctx) {
        ctx.clearRect(0, 0, canvasCurrent.width, canvasCurrent.height); // ensure transparency
      }
    }
  }, [refOBj]);

  return (
    <>
      <Grid
        className="signature-pad-container"
        style={{
          borderColor: lighten(theme.palette.secondary.light, 0.2),
          borderStyle: "solid",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "5px",
        }}
      >
        <Typography
          sx={{
            fontSize: "1.2em",
            fontStyle: "italic",
            fontWeight: 800,
          }}
        >
          {text}
        </Typography>
        <SignaturePad
          options={{
            minWidth: minPencilWidth ?? 2,
            maxWidth: maxPencilWidth ?? 3,
            penColor: "rgb(66, 133, 244)",
            backgroundColor: "transparent",
          }}
          ref={refOBj}
          redrawOnResize
          canvasProps={{
            className: "signCanvas",
          }}
        />
      </Grid>
    </>
  );
};

export default SignaturePadContainer;
